module.exports = __webpack_public_path__ + "static/dailyhabits-eff20ade03103e179115e7e1632156ed.png";